export default "__VITE_ASSET__bfa06051__"